import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/lib/Modal';
import BlockContent from '@sanity/block-content-to-react';

export class LegalDocumentModal extends React.Component {
    legalModalBodyRef = null;

    handleLegalContentClick = (event) => {
        let target = event.target;
        while (target && target.tagName !== 'A' && target !== event.currentTarget) {
            target = target.parentNode;
        }
        if (!target || target.tagName !== 'A') {
            return;
        }

        const href = target.getAttribute('href');
        if (!href) {
            return;
        }

        let parsedHref = null;
        try {
            parsedHref = new URL(href, window.location.href);
        } catch (error) {
            parsedHref = null;
        }
        const isHttpLink = parsedHref && /^https?:$/i.test(parsedHref.protocol);
        const isExternalHttpLink = isHttpLink && parsedHref.origin !== window.location.origin;

        let hashIndex = href.indexOf('#');
        if (hashIndex === -1 && parsedHref && parsedHref.hash) {
            hashIndex = href.length - parsedHref.hash.length;
        }

        if (hashIndex === -1) {
            if (isExternalHttpLink) {
                event.preventDefault();
                window.open(parsedHref.toString(), '_blank', 'noopener,noreferrer');
            }
            return;
        }

        const hashValue = parsedHref && parsedHref.hash ? parsedHref.hash : href.substring(hashIndex);
        const targetId = decodeURIComponent(hashValue.substring(1));
        if (!targetId || !this.legalModalBodyRef) {
            if (isExternalHttpLink) {
                event.preventDefault();
                window.open(parsedHref.toString(), '_blank', 'noopener,noreferrer');
            }
            return;
        }

        const elementsWithId = this.legalModalBodyRef.querySelectorAll('[id]');
        let targetElement = null;
        for (let i = 0; i < elementsWithId.length; i++) {
            if (elementsWithId[i].getAttribute('id') === targetId) {
                targetElement = elementsWithId[i];
                break;
            }
        }

        if (!targetElement) {
            const tocMatch = /^toc(\d+)$/i.exec(targetId);
            if (tocMatch) {
                const headingIndex = parseInt(tocMatch[1], 10) - 1;
                const headings = this.legalModalBodyRef.querySelectorAll('h1, h2, h3, h4, h5, h6');
                if (headingIndex >= 0 && headingIndex < headings.length) {
                    targetElement = headings[headingIndex];
                }
            }
        }

        if (targetElement) {
            event.preventDefault();
            targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return;
        }

        if (isExternalHttpLink) {
            event.preventDefault();
            window.open(parsedHref.toString(), '_blank', 'noopener,noreferrer');
        }
    }

    privacyBlockRenderer = (props) => {
        const { style = 'normal', markDefs = [] } = props.node;
        let htmlIdMarkDef = null;
        for (let i = 0; i < markDefs.length; i++) {
            if (!htmlIdMarkDef && markDefs[i] && markDefs[i].html_id) {
                htmlIdMarkDef = markDefs[i];
            }
        }

        if (/^h[1-6]$/i.test(style) && htmlIdMarkDef && htmlIdMarkDef.html_id) {
            return React.createElement(style.toLowerCase(), { id: htmlIdMarkDef.html_id }, props.children);
        }
        if (/^h[1-6]$/i.test(style) && props.node.children && props.node.children[0] && props.node.children[0].text) {
            return React.createElement(style.toLowerCase(), { id: props.node.children[0].text }, props.children);
        }
        return BlockContent.defaultSerializers.types.block(props);
    }

    render() {
        const { show, onHide, onClose, isLegalError, isLegalLoading, legalContent, t } = this.props;

        return (
            <Modal
                show={show}
                onHide={onHide}
                bsClass="legal-document-modal">
                <Modal.Header closeButton>
                    <Modal.Title>{t('legal_document:header', 'Legal document')}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="legal-document-modal-body" ref={(node) => { this.legalModalBodyRef = node; }}>
                    {isLegalError && (
                        <div className="legal-document-error-row" role="alert">
                            <span className="legal-document-error-icon" aria-hidden="true" />
                            <span className="legal-document-error-text">
                                {t('legal_document:cannot_retrieve.info_with_try_again_prompt', 'Document cannot be retrieved at the moment. Come back later.')}
                            </span>
                        </div>
                    )}
                    {!isLegalLoading && !isLegalError && legalContent && (
                        <div className="consent-text" onClick={this.handleLegalContentClick}>
                            <BlockContent
                                blocks={legalContent}
                                serializers={{ types: { block: this.privacyBlockRenderer } }} />
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    {isLegalError && (
                        <a
                            className="legal-document-support-link"
                            href="//support.polar.com/support/flow?blredir"
                            target="_blank"
                            rel="noopener noreferrer">
                            {t('legal_document:cannot_retrieve.link_to_care', 'Contact customer service.')}
                        </a>
                    )}
                    <button type="button" className="legal-document-modal-ok-button" onClick={onClose}>
                        {t('common:ok', 'OK')}
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}

LegalDocumentModal.propTypes = {
    show: PropTypes.bool,
    onHide: PropTypes.func,
    onClose: PropTypes.func,
    isLegalError: PropTypes.bool,
    isLegalLoading: PropTypes.bool,
    legalContent: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    t: PropTypes.func
};

export default LegalDocumentModal;



// WEBPACK FOOTER //
// ./src/UserSettings/components/PrivacyView/Consent/LegalDocumentModal.jsx